import localStorageService from '@/core/local-storage'
import { authService, profileService } from '@/services'
import router from '@/router'
import createDefaultProjects from '@/onboarding/createDefaultProjects'

export default {
  state: {
    token: localStorageService.getItem('HelloIvyToken') || '',
    showWelcomeModal: false, // delete before deploy
    signupRequests: 0
  },

  mutations: {
    setToken (state, value) {
      state.token = value
      localStorageService.setItem('HelloIvyToken', value)
    },

    removeToken (state) {
      state.token = ''
      localStorageService.removeItem('HelloIvyToken')
    },

    showWelcomeModal (state, value) {
      state.showWelcomeModal = value
    },

    setRequestCount (state, value) {
      state.signupRequests = value === 0 ? 0 : state.signupRequests + 1
    }
  },

  actions: {
    signIn ({ commit }, user) {
      commit('loading', true)
      return authService.login(user).then(({ data }) => {
        commit('setToken', data.token)
      }).catch(({ data }) => Promise.reject(data))
    },

    async createDefaultProjects ({ commit, rootState }) {
      try {
        const settings = rootState.settings.settings
        commit('loading', true)

        await createDefaultProjects(commit, settings)

        return Promise.resolve()
      } catch (err) {
        commit('loading', false)
        return Promise.reject(err)
      }
    },

    async signUp ({ commit, dispatch }, user) {
      commit('loading', true)

      try {
        // create user and set token
        const userData = await authService.register(user)
        commit('setToken', userData.data.token)

        await dispatch('createDefaultProjects')

        return Promise.resolve()
      } catch (err) {
        commit('loading', false)
        return Promise.reject(err)
      }
    },

    socialLogin ({ commit }) {
      commit('loading', true)
      authService.socialLogin().then(({ data }) => {
        commit('setToken', data.token)
        router.push('/')
      })
    },

    logoutRedirect ({ commit }, next) {
      commit('setInvoices', null)
      commit('removeToken')
      commit('removeTeam')
      commit('changeActiveState', 'Account')
      commit('setTemplates', [])
      next()
    },

    restoreAccount ({ commit }, user) {
      commit('loading', true)
      return profileService.restore(user).then(({ data }) => {
        commit('setToken', data.token)
      }).catch(({ data }) => Promise.reject(data))
    }
  }
}
